import { DateTime } from "luxon";

export const FILE_SHORT_DATE_FORMAT = "MM.dd.yyyy";

type AgeUnit = "days" | "hours" | "minutes" | "seconds" | "milliseconds";

const unitSuffixes: Record<AgeUnit, string> = {
	days: "d",
	hours: "hr",
	minutes: "m",
	seconds: "s",
	milliseconds: "ms",
};

const formatAge = (date: Date, units: AgeUnit[], emptyFallback: string): string => {
	const diff = DateTime.now().diff(DateTime.fromJSDate(date), units);

	const parts = units
		.map((unit) => Math.floor(diff.get(unit)))
		.map((value, index) => (value > 0 ? `${value}${unitSuffixes[units[index]]}` : null))
		.filter((part): part is string => part !== null);

	return parts.length > 0 ? parts.join(" ") : emptyFallback;
};

export const formatAgeMinutes = (date: Date): string => formatAge(date, ["days", "hours", "minutes"], "0m");

export const formatAgeSeconds = (date: Date): string => formatAge(date, ["days", "hours", "minutes", "seconds"], "0s");

export const formatAgeMilliseconds = (date: Date): string =>
	formatAge(date, ["days", "hours", "minutes", "seconds", "milliseconds"], "0ms");
